/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import { Button, Card, message, Popconfirm, Space, Table } from 'antd'
import PageHeader from '@/components/PageHeader'
import { SelectC, Search } from '@/i2antdV5'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { fetchJPositionList } from '@/redux/components/getJPositionListSlice'
import { fetchJDepartmentList } from '@/redux/components/getJDepartmentListSlice'
import { fetchSystemAgentsList } from '@/redux/use/systemAgentSlice'
import { store } from '@/redux/store'
import { formatDateTimeStr, renderTextStr, renderPhoneStr } from '@/utils/renderUtils'
import { deleteSystemAgent } from '@/service/systemControl'
import AgentAssignRolesModal from './share/AgentAssignRolesModal'
import AgentDrawer from './share/AgentDrawer'

const breadcrumbList = [
  { breadcrumbName: '首页', href: '/client/commandCenter' },
  { breadcrumbName: '用户中心' },
  { breadcrumbName: '管理员列表' }
]

const AGENT_TYPE_OPTIONS = [
  { id: '1', value: '超级管理员' },
  { id: '2', value: '员工' }
]

const LOGIN_PERMISSION_OPTIONS = [
  { id: '1', value: '允许登录' },
  { id: '2', value: '禁止登录' }
]

const AGENT_STATE_OPTIONS = [
  { id: '1', value: '在职' },
  { id: '2', value: '离职' },
  { id: '3', value: '调店' }
]

/** 列表默认查询（仅页面侧使用，不写入 Redux initialState） */
const DEFAULT_AGENTS_LIST_QUERY = {
  pageNumber: 1,
  pageSize: 20,
  orderBy: 'create_time',
  orderDirection: 'desc',
  state: 1
}

const mergeAgentsQuery = (reduxQuery) =>
  reduxQuery && Object.keys(reduxQuery).length > 0 ? reduxQuery : DEFAULT_AGENTS_LIST_QUERY

class AgentsListPage extends React.Component {
  async componentDidMount() {
    try {
      await this.props.fetchJStoreList({ query: {}, dataType: 'option' }).unwrap()
    } catch (err) {
      message.error(typeof err === 'string' ? err : '加载门店列表失败')
    }
    const options = store.getState().components.getJStoreList?.data || []
    const firstStoreId = options[0]?.id
    const query = {
      ...DEFAULT_AGENTS_LIST_QUERY,
      ...(firstStoreId != null && firstStoreId !== '' ? { storeId: String(firstStoreId) } : {})
    }
    const commonStoreQuery =
      firstStoreId != null && firstStoreId !== '' ? { storeId: String(firstStoreId) } : {}
    try {
      await Promise.all([
        this.props.fetchJPositionList({ query: commonStoreQuery, dataType: 'option' }).unwrap(),
        this.props.fetchJDepartmentList({ query: commonStoreQuery, dataType: 'option' }).unwrap(),
        this.props.fetchSystemAgentsList({ query }).unwrap()
      ])
    } catch (err) {
      message.error(typeof err === 'string' ? err : '加载职位、部门或管理员列表失败')
    }
  }

  refreshAgentList = () => {
    const q = mergeAgentsQuery(this.props.systemAgent.query)
    this.fetchAgents(q)
  }

  fetchAgents = (formatQuery) => {
    this.props
      .fetchSystemAgentsList({ query: formatQuery })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载管理员列表失败'))
  }

  handleTableChange = (pagination) => {
    const query = mergeAgentsQuery(this.props.systemAgent.query)
    this.fetchAgents({
      ...query,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize
    })
  }

  handleDeleteAgent = async (record) => {
    const id = record?.id
    if (id == null) {
      message.error('缺少成员 id')
      return
    }
    try {
      await deleteSystemAgent(id)
      message.success('删除成功')
      this.refreshAgentList()
    } catch (e) {
      const msg =
        e?.response?.data?.msg ||
        e?.response?.data?.message ||
        e?.message ||
        '删除失败'
      message.error(typeof msg === 'string' ? msg : '删除失败')
    }
  }

  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'id',
        width: 72,
        fixed: 'left'
      },
      {
        title: '登录账号',
        dataIndex: 'account',
        width: 120,
        ellipsis: true,
        render: (v) => renderTextStr(v)
      },
      {
        title: '用户名',
        dataIndex: 'userName',
        width: 100,
        ellipsis: true,
        render: (v) => renderTextStr(v)
      },
      {
        title: '店铺',
        dataIndex: 'storeName',
        width: 160,
        ellipsis: true,
        render: (v) => renderTextStr(v)
      },
      {
        title: '手机号',
        dataIndex: 'phone',
        width: 120,
        ellipsis: true,
        render: (v) => renderPhoneStr(v)
      },
      {
        title: '用户类型',
        dataIndex: 'typeText',
        width: 108,
        ellipsis: true,
        render: (v) => renderTextStr(v)
      },
      {
        title: '在职状态',
        dataIndex: 'stateText',
        width: 88,
        ellipsis: true,
        render: (v) => renderTextStr(v)
      },
      {
        title: '上次登录',
        dataIndex: 'loginTime',
        width: 168,
        render: (v) => formatDateTimeStr(v)
      },
      {
        title: '操作',
        key: 'actions',
        width: 200,
        fixed: 'right',
        render: (_, record) => (
          <Space size={0} wrap>
            <AgentDrawer
              actType="edit"
              record={record}
              onSuccess={this.refreshAgentList}
            >
              <Button
                type="link"
                size="small"
                danger={false}
                style={{ color: 'var(--ant-color-primary, #1677ff)' }}
              >
                编辑
              </Button>
            </AgentDrawer>
            <AgentAssignRolesModal record={record} onSuccess={this.refreshAgentList}>
              <Button
                type="link"
                size="small"
                danger={false}
                style={{ color: 'var(--ant-color-primary, #1677ff)' }}
              >
                分配角色
              </Button>
            </AgentAssignRolesModal>
            <Popconfirm
              title="确认删除该成员？"
              description={record.account ? `登录账号：${record.account}` : undefined}
              okText="删除"
              okButtonProps={{ danger: true }}
              onConfirm={() => this.handleDeleteAgent(record)}
            >
              <Button type="link" size="small" danger>
                删除
              </Button>
            </Popconfirm>
          </Space>
        )
      }
    ]
  }

  render() {
    const { systemAgent, getJStoreList, getJPositionList, getJDepartmentList } = this.props
    const { fetching, query: reduxQuery, data = {} } = systemAgent
    const query = mergeAgentsQuery(reduxQuery)
    const jStoreOptions = getJStoreList?.data || []
    const { data: positionOptions = [] } = getJPositionList
    const { data: departmentOptions = [] } = getJDepartmentList
    const { list = [], totalRow = 0, pageNumber = 1, pageSize = 20 } = data
    const headerAction = (
      <AgentDrawer actType="create" onSuccess={this.refreshAgentList}>
        <Button type="primary">新增管理员</Button>
      </AgentDrawer>
    )
    return (
      <div>
        <PageHeader breadcrumbList={breadcrumbList} extra={headerAction} />
        <div className="i2-container">
          <Card className="i2-card-page">
            <section className="i2-app-toolbar">
              <div className="toolbar-filters">
                <SelectC
                  label="门店"
                  query={query}
                  searchKey="storeId"
                  options={jStoreOptions}
                  action={this.fetchAgents}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
                <Search
                  label="关键字"
                  query={query}
                  searchKey="keyword"
                  action={this.fetchAgents}
                  modalProps={{ allowClear: true, placeholder: '姓名/手机号/账号' }}
                />
                <SelectC
                  label="用户类型"
                  query={query}
                  searchKey="type"
                  options={AGENT_TYPE_OPTIONS}
                  action={this.fetchAgents}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
                <SelectC
                  label="在职状态"
                  query={query}
                  searchKey="state"
                  options={AGENT_STATE_OPTIONS}
                  action={this.fetchAgents}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
                <SelectC
                  label="部门"
                  query={query}
                  searchKey="departmentId"
                  options={departmentOptions}
                  action={this.fetchAgents}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
                <SelectC
                  label="职位"
                  query={query}
                  searchKey="positionId"
                  options={positionOptions}
                  action={this.fetchAgents}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
              </div>
            </section>
            <Table
              loading={fetching}
              columns={this.getColumns()}
              dataSource={list}
              rowKey={(r) => String(r.id)}
              size="small"
              tableLayout="fixed"
              scroll={{ x: 2240 }}
              onChange={this.handleTableChange}
              pagination={{
                current: pageNumber,
                pageSize,
                total: totalRow,
                showSizeChanger: true,
                showTotal: (t) => `共 ${t} 条`,
                pageSizeOptions: ['10', '20', '50', '100']
              }}
            />
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  systemAgent: state.use.systemAgent,
  getJStoreList: state.components.getJStoreList,
  getJPositionList: state.components.getJPositionList,
  getJDepartmentList: state.components.getJDepartmentList
})

const mapDispatchToProps = {
  fetchSystemAgentsList,
  fetchJStoreList,
  fetchJPositionList,
  fetchJDepartmentList
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentsListPage)
